import React from "react";

import MedilineLogo from "../../../assets/img/logo-mediline-white.png";

const LoginSlider = () => {
  return (
    <div className="login-slider">
      <img className="login-slider__logo" src={MedilineLogo} alt="Televet" />
    </div>
  );
};

export default LoginSlider;
